import { useLang } from "@/i18n/LangContext";

export default function LangToggle({ subtle = false }) {
  const { lang, setLang } = useLang();
  const base = "text-[11px] tracking-monocle uppercase transition-colors duration-300";
  const active = "text-[var(--ink)]";
  const inactive = "text-[var(--ink-faint)] hover:text-[var(--ink)]";
  return (
    <div className={`flex items-center gap-2 ${subtle ? "" : ""}`} data-testid="lang-toggle">
      <button
        onClick={() => setLang("pt")}
        className={`${base} ${lang === "pt" ? active : inactive}`}
        data-testid="lang-toggle-pt"
      >
        PT
      </button>
      <span className="text-[var(--ink-faint)] text-xs">·</span>
      <button
        onClick={() => setLang("en")}
        className={`${base} ${lang === "en" ? active : inactive}`}
        data-testid="lang-toggle-en"
      >
        EN
      </button>
    </div>
  );
}
